import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { calculateDigit, withMode } from "./..";
import { ProFormDigitRange } from '@ant-design/pro-components';
import _ from 'lodash';
import React from 'react';
export var ProFormPreciseDigitRange = function ProFormPreciseDigitRange(properties) {
  return /*#__PURE__*/React.createElement(ProFormDigitRange, _extends({}, properties, {
    formItemProps: _objectSpread(_objectSpread({}, properties.formItemProps), {}, {
      getValueFromEvent: function getValueFromEvent(value) {
        return value.map(function (value0) {
          return calculateDigit(value0, withMode(properties, 'edit'));
        });
      },
      getValueProps: function getValueProps(value) {
        if (value) {
          return {
            value: value.filter(_.isNumber).map(function (value0) {
              return calculateDigit(value0, withMode(properties, 'read'));
            })
          };
        } else {
          return {};
        }
      }
    })
  }));
};